import { type Ref } from 'react';
import IconCalendar from '@creditflowresearch/uilib/Icon/IconCalendar';
import Input from '@creditflowresearch/uilib/Input';

import styles from '@/creditflowresearch/ui/common/components/DatePicker/styles/dateRangeFilter.module.scss';

interface IDateInputProps {
  ref?: Ref<HTMLInputElement>,
  name: string,
  dataTest: string,
  label?: string,
  isClearable?: boolean,
  onClear?: () => void,
}

const DateInput = ({ ref, name, dataTest, label, onClear, isClearable = true, ...inputProps }: IDateInputProps) => (
  <div className={ styles.field }>
    { label && <span className={ styles.label }>{ label }</span> }
    { /* @ts-ignore — uikit Input `input` prop expects FieldInputProps but react-datepicker passes different shape via customInput */ }
    <Input
      input={ { ref, ...inputProps } as any }
      icon={ IconCalendar }
      iconPosition="right"
      isNarrow
      isClearable={ isClearable }
      onClear={ onClear }
      name={ name }
      dataTest={ dataTest }
    />
  </div>
);

export default DateInput;
